import React from 'react'
import { Helmet } from 'react-helmet-async'
import Contact from "@/components/main/contact";
import Spiral from "@/components/fx/spiral";
import { LocalBusinessSchema, BreadcrumbSchema } from '@/components/StructuredData'

export default function ContactPage() {
  if (
    typeof window !== "undefined" &&
    window.location.href.includes("kapcsolat")
  ) {
    console.log(window.location.href);
  }

  return (
    <>
      <Helmet>
        <title>Kapcsolat | BeArt Művészetterápia</title>
        <meta name="description" content="BeArt Művészetterápia kapcsolat - művészetterápiás csoportok, egyéni és csoportos alkalmak" />
        <link rel="canonical" href="https://beart.hu/kapcsolat" />
      </Helmet>
      
      {/* Structured Data */}
      <LocalBusinessSchema 
        address={{
          streetAddress: "Bartók Béla út 22.",
          addressLocality: "Budapest",
          postalCode: "1111",
          addressCountry: "HU"
        }}
        telephone="+36-30-XXX-XXXX"
      />
      <BreadcrumbSchema 
        items={[
          { name: "Főoldal", url: "https://beart.hu" },
          { name: "Kapcsolat", url: "https://beart.hu/kapcsolat" }
        ]} 
      />
      
      <div className="">
        <Spiral />
      </div>
      <section className="mx-auto mb-8 mt-8 flex w-3/4 rounded-lg bg-[#ffcc99] bg-opacity-50 text-black shadow">
        <Contact title="Kapcsolat" hidden="" />
      </section>
      <div className="mx-auto w-3/4">
        <p>
          <strong>Adatkezelési tájékoztatás:</strong> Az űrlap kitöltésével
          hozzájárulsz adataid kommunikáció és kapcsolattartás céljára történő
          kezeléséhez. Az Európai Parlament és Tanács (EU) 2016/679. rendelete
          (továbbiakban: GDPR) a személyes adatok kezelésére vonatkozó rendelete
          az irányadó az adatok kezelésében.
        </p>
      </div>
    </>
  )
}
